import { TipoOcorrencia } from '@acme/core'
import { FormField, FormFieldSelect } from 'global/components/Form'
import Grid from 'global/components/ui/Grid'
import { HeartPulseIcon } from 'lucide-react'
import { ocorrencia } from 'service/api'
import type { AcaoUi } from './acao-ui'

function ParametrosLancarAfastamento() {
    const { data: ocorrencias = [] } = ocorrencia.useFetch()

    return (
        <>
            <Grid item xs={12}>
                <FormFieldSelect
                    name="parametros.ocorrenciaId"
                    label="Ocorrência"
                    required
                    options={ocorrencias
                        .filter(it => it.tipo === TipoOcorrencia.AFASTAMENTO)
                        .map(it => ({ value: it.id, label: it.descricao }))}
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="parametros.justificativa"
                    label="Justificativa"
                />
            </Grid>
        </>
    )
}

/** Começa sem `ocorrenciaId` para o Zod acusar "Obrigatório" até a escolha. */
export const lancarAfastamento: AcaoUi = {
    icone: HeartPulseIcon,
    parametrosIniciais: {},
    Parametros: ParametrosLancarAfastamento,
}
